import { render, staticRenderFns } from "./WDS3DataEditor.vue?vue&type=template&id=13955c96&scoped=true"
import script from "./WDS3DataEditor.vue?vue&type=script&lang=js"
export * from "./WDS3DataEditor.vue?vue&type=script&lang=js"
import style0 from "./WDS3DataEditor.vue?vue&type=style&index=0&id=13955c96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13955c96",
  null
  
)

export default component.exports